import React from 'react';
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectClosedTasksTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectClosedTasksTab/components/ProspectClosedTasksTabListing/ProspectClosedTasksTabListing";
import BaseTaskTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseTaskTab/BaseTaskTab";

export default function ProspectClosedTasksTab() {
    const {currentRoute} = useNavigation();
    const {prospect: prospectId} = currentRoute.params;

    return (
        <BaseTaskTab
            listingComponent={<ProspectClosedTasksTabListing prospectId={prospectId}/>}
        />
    )
}
